import React from 'react'
import { Controller } from 'react-hook-form'
import { date, Explination } from '@enkla-gui'
import DatePicker from 'react-datepicker'

import sv from 'date-fns/locale/sv'

export default function Date({ controls, today = false, name, placeholder, label, tip = false, error = false, cols = 'col', options }) {
  var { control } = controls
  const id = `field-${name}`
  const errorId = `${id}-error`
  var message
  const hasError = () => {
    var data = error.data
    if (data === undefined) return false
    name.split('.').forEach(value => {
      if (value in data) {
        data = data[value]
      } else {
        data = []
      }
    })
    if (data.length === 0) return false
    message = Array.isArray(data) ? data[0] : data
    return true
  }
  const showError = error && hasError()
  return (
    <div class={`component_Date ${cols}`}>
      <div class='form-group'>
        <label htmlFor={id}>
          {label} {tip && <Explination tip={tip} />}
          {options?.required && <span class='input-required'> * </span>}
        </label>
        <Controller
          control={control}
          name={name}
          rules={options}
          render={({ field }) => (
            <DatePicker
              id={id}
              className='form-control'
              locale={sv}
              dateFormat='yyyy-MM-dd'
              placeholderText={placeholder}
              onChange={_date => field.onChange(_date === null ? (today ? date.today() : null) : date.fixTimezone(_date) / 1000)}
              selected={field.value * 1000}
              aria-invalid={showError ? 'true' : undefined}
              aria-describedby={showError ? errorId : undefined}
              aria-required={options?.required ? 'true' : undefined}
            />
          )}
        />
        {showError && (
          <div class='form-inline-error' id={errorId}>
            <i class='fa fa-fw fa-exclamation-triangle' aria-hidden="true" /> {message}
          </div>
        )}
      </div>
    </div>
  )
}
